import { createApi } from './core';
import { Address } from './accounts.types';
import { Patient } from './patients.types';

declare const healConfig: any;

function createAccountsApi() {
  return createApi({ baseURL: healConfig.apiBaseUrl + '/admin' });
}

export function createAccount(data: any): Promise<any> {
  return createAccountsApi()
    .then((api) => api.post<any>(`/create-visit/create-account`, data))
    .then((r) => (r.ok && r.data ? r.data.account : Promise.reject(new Error((r.data as any).description))));
}

export function fetchAccount(id: string): Promise<any> {
  return createAccountsApi()
    .then((api) => api.get<any>(`/create-visit/${id}/info`))
    .then((r) => r.ok && r.data);
}

export function createAddress(id: string, data: Omit<Address, 'addressId'>): Promise<Address> {
  return createAccountsApi()
    .then((api) => api.post<Address>(`/create-visit/${id}/create-address`, data))
    .then((r) => (r.ok ? r.data! : Promise.reject(new Error((r.data as any).description))));
}

export function editAddress(data: Address): Promise<Address> {
  return createAccountsApi()
    .then((api) => api.put<Address>(`/create-visit/address/${data.addressId}`, data))
    .then((r) => (r.ok ? r.data! : Promise.reject(new Error((r.data as any).description))));
}

export function deleteUserAccount(id: string, hardDelete: boolean): Promise<boolean> {
  return createAccountsApi()
    .then((api) => api.delete<any>(`/accounts/${id}?hardDelete=${hardDelete}`))
    .then((r) => r.ok);
}

export function updateUserAccountUsername(id: string, username: string): Promise<boolean> {
  return createAccountsApi()
    .then((api) => api.patch<any>(`/accounts/${id}`, { username }))
    .then((r) => r.ok);
}

export function promotePatient(patientId: string): Promise<Patient> {
  return createAccountsApi()
    .then((api) => api.put<Patient>(`/patient/${patientId}/promote`))
    .then((r) => (r.ok ? r.data! : Promise.reject(new Error((r.data as any).description))));
}

export function updatePatientUserAccount(patientId: string, newUserAccountId: string, newRelationshipId: string): Promise<Patient> {
  return createAccountsApi()
    .then((api) =>
      api.put<Patient>(`/patient/${patientId}/updateUserAccount`, {
        newUserAccountId,
        newRelationshipId,
      })
    )
    .then((r) => (r.ok ? r.data! : Promise.reject(new Error((r.data as any).description))));
}

export function resetPassword(username: string) {
  let baseURL = `https://api.${healConfig.env}.heal.com/user/`;
  if (healConfig.env === 'prd') {
    baseURL = `https://api.heal.com/user/`;
  }

  return createApi({ baseURL, hideMessage: true })
    .then((api) => api.post('/reset_password', { username }))
    .then((r) => r.ok);
}


export function reactivateUserAccount(userAccountId: string): Promise<boolean> {
  return createAccountsApi()
      .then((api) => api.patch<any>(`/accounts/${userAccountId}`, { active: true }))
      .then((r) => r.ok);
}